
export class User {
  constructor(
    public adminCommitteeIds: number[] = [],
    public externalId: string = '',
    public email: string = '',
    public firstName: string = '',
    public lastName: string = '',
    public title: string = '',
    public userName: string = '',
    public lawId: string = '',
    public isMember: boolean = false,
    public isPcHolder: boolean = false,
    public isPrincipal: boolean = false,
    public isTester: boolean = false,
    public isExternalExaminer: boolean = false,
    public isTrustContact: boolean = false,
    public isTrustCoordinator: boolean = false,
    public securityGroups: string = '',
    public roles: Role[] = [],
    public impersonatedLawId: string = '',
    public originalDisplayName: string = '',
    public originalFirstName: string = '',
    public originalLastName: string = '',
    public originalLawId: string = '',
    public lawIdUserTypeId: number = 0,
    public isInactiveExternalExaminer: boolean = false,
  ) { }
}

export type Role = RoleType.Tester | RoleType.Principal | RoleType.TrustContact |
  RoleType.TrustCoordinators | RoleType.KeyContact | RoleType.ExternalExaminer | RoleType.ToBeExternalExaminer;

export enum RoleType {

  // Impersonate
  Tester = 'Tester',

  // Dashboard
  Principal = 'Principal',
  TrustCoordinators = 'TrustCoordinators',
  KeyContact = 'KeyContact',

  // EE Dashboard
  ExternalExaminer = 'ExternalExaminer',
  ToBeExternalExaminer = 'ToBeExternalExaminer',
  TrustContact = 'TrustContact',

}

export type LawIDUser = LawIDUserType.PrincipalTrustCoordinatorTrustContact | LawIDUserType.ExternalExaminer | LawIDUserType.ToBeExternalExaminer;

export enum LawIDUserType {
  PrincipalTrustCoordinatorTrustContact = 1,
  ExternalExaminer = 2,
  ToBeExternalExaminer = 3,
}

export function accessPermitted(userRoles: Role[], allowedRoles: Role[] = []): boolean {
  let accessAllowed = false;
  userRoles.forEach((x) => {
    if (allowedRoles.filter(y => y == x).length > 0) {
      accessAllowed = true;
    }
  });
  return accessAllowed;
}
